import React, { Component, useState, useEffect } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import SLStepper from "../editors/SLStepper";
 
const StepperComponent = ({ currentStep, stepData }) => {
  const [progressValue, setProgressValue] = useState(0);
  const [currentStepState, setCurrentStepState] = useState(currentStep);

  useEffect(() => {
    let value = Math.floor(((currentStep + 1) / stepData.length) * 100);
    if (value <= 100) setProgressValue(value);
    if (currentStep < stepData.length) setCurrentStepState(currentStep);
  }, [currentStep]);

  return (
    <div className={"progress-margin mb-0 mt-5"}>
      <div className={"text-center mb-0"}>
        {currentStepState +
          1 +
          "  of  " +
          stepData.length +
          "  " +
          "(" +
          progressValue +
          "%" +
          ")"}
      </div>
      <SLStepper activeStep={currentStepState} steps={stepData} />
    </div>
  );
};

StepperComponent.propTypes = {
  stepData: PropTypes.array.isRequired,
  currentStep: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  const { language } = state.users;

  return {
    language,
  };
}

export default connect(mapStateToProps)(StepperComponent);



// WEBPACK FOOTER //
// ./src/components/subcomponents/Stepper.jsx